// Week 10 / Day 5 — Final Gate: Creator Light (bilingual RU/EN inline).
// Final quest day — collects all 5 lights. Educational only.
// Game page and unlock logic will be added in Part C; this file only ships content text.

export const maxWeek10Day5 = {
  id: 'max-week-10-day-5',
  studentId: 'max',
  weekId: 'week-10',
  dayId: 'day-5',
  title: 'Финальные ворота: огонёк создателя / Final Gate: Creator Light',
  shortTitle: 'Финальные ворота / Final Gate',
  theme:
    'Нимни собирает все огоньки знаний и готовится открыть ночную игру. / Nimny collects all the lights of knowledge and gets ready to unlock the night game.',
  estimatedTimeLabel:
    'Финальная квестовая часть и устный итог: около 30–45 минут. Паспорт миссии и проверка с родителем — около 50–70 минут всего. / Final quest and oral wrap-up: 30–45 minutes. Mission passport and parent check — 50–70 minutes total.',
  nimnyIntro:
    'Перед Нимни финальные ворота. Чтобы открыть их, нужно собрать все огоньки: деньги, банк, мир, идеи и создатель. Это последняя миссия перед ночной игрой. / The final gate is in front of Nimny. To open it, collect all the lights: money, bank, world, ideas and creator. This is the last mission before the night game.',
  goals: [
    'Огонёк знаний № 5: создатель + сборка всех огоньков. / Light of knowledge #5 + collect all lights.',
    'Слой 1. Математика / Layer 1. Math: смешанный обзор — бюджет, баланс, маршрут, прибыль, время (Grade 5 / middle).',
    'Слой 2. Русский язык / Layer 2. Russian: словарь финальной миссии и мини-диктант.',
    'Слой 3. Чтение и итоговое письмо / Layer 3. Reading and final writing: 5–7 предложений «Чему я научился с Нимни?».',
    'Слой 4. Финальная сортировка / Layer 4. Final sorting: 10 карточек по 5 огонькам. / 10 cards into 5 lights.',
    'Слой 5. Финальные ворота: код огоньков и рисунок / Layer 5. Final Gate: lights code and drawing.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 5/8.'
  ],
  vocabulary: [
    { term: 'деньги / money', definition: 'способ обмена, который мы считаем / a way of exchange we count' },
    { term: 'банк / bank', definition: 'место записей о нимах / a place that keeps records' },
    { term: 'карта / map', definition: 'вид мест сверху / view from above' },
    { term: 'маршрут / route', definition: 'путь от старта к финишу / start-to-finish path' },
    { term: 'источник / source', definition: 'тот, кто или что говорит / who or what tells it' },
    { term: 'создатель / creator', definition: 'тот, кто думает, проверяет и объясняет / one who thinks, checks and explains' },
    { term: 'идея / idea', definition: 'полезная мысль / a useful thought' },
    { term: 'риск / risk', definition: 'возможность другого результата / chance of a different result' },
    { term: 'привычка / habit', definition: 'действие, которое мы повторяем / an action we repeat' },
    { term: 'вывод / conclusion', definition: 'итог после раздумья / a result after thinking' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Бюджет финала / Final budget',
      prompt: 'Бюджет 50 нимов. Выбраны: 15, 20, 10. Какова сумма? Помещается ли в 50? / Budget 50. Picks: 15, 20, 10. Sum? Fits in 50?',
      helper: '15 + 20 + 10. / 15 + 20 + 10.', answer: '15 + 20 + 10 = 45 нимов; помещается (≤ 50). / 45 nims; fits (≤ 50).' },
    { id: 'q2', type: 'math', title: 'Баланс счёта / Account balance',
      prompt: '80 + 20 − 15 = ? / 80 + 20 − 15 = ?',
      helper: '80 + 20 − 15. / 80 + 20 − 15.', answer: '85', unit: 'нимов / nims' },
    { id: 'q3', type: 'math', title: 'Длина маршрута / Route distance',
      prompt: '100 + 120 + 80 = ? метров / meters',
      helper: '100 + 120 + 80. / Sum.', answer: '300', unit: 'метров / meters' },
    { id: 'q4', type: 'math', title: 'Прибыль / Profit',
      prompt: 'Выручка 60 нимов, расходы 35 нимов. Прибыль? / Revenue 60, expenses 35. Profit?',
      helper: '60 − 35. / 60 − 35.', answer: '25', unit: 'нимов / nims' },
    { id: 'q5', type: 'math', title: 'Время в ленте / Feed time',
      prompt: '5 коротких видео по 40 секунд. Сколько секунд всего? / 5 videos × 40 s. Total seconds?',
      helper: '5 × 40. / 5 × 40.', answer: '200', unit: 'секунд / seconds' },
    { id: 'q6', type: 'classify', title: 'Финальная сортировка по 5 огонькам / Final sorting into 5 lights',
      prompt: 'Распредели карточки по огонькам. / Sort the cards into the lights.',
      categories: [
        { id: 'money', label: 'Огонёк денег / Money light' },
        { id: 'bank',  label: 'Огонёк банка / Bank light' },
        { id: 'world', label: 'Огонёк мира / World light' },
        { id: 'ideas', label: 'Огонёк идей / Ideas light' },
        { id: 'creator', label: 'Огонёк создателя / Creator light' }
      ],
      items: [
        { id: 'budget',  text: 'бюджет / budget' },
        { id: 'pin',     text: 'PIN' },
        { id: 'scale',   text: 'масштаб / scale' },
        { id: 'profit',  text: 'прибыль / profit' },
        { id: 'source',  text: 'источник / source' },
        { id: 'map',     text: 'карта / map' },
        { id: 'risk',    text: 'риск / risk' },
        { id: 'creator_word', text: 'creator' },
        { id: 'check_info', text: 'проверить информацию / check information' },
        { id: 'save_part',  text: 'отложить часть / save a part' }
      ] },
    { id: 'q7', type: 'classify', title: 'Код финальных ворот / Final gate code',
      prompt: 'Подбери одно слово на каждый огонёк. / Match one word to each light.',
      categories: [
        { id: 'money',   label: 'Огонёк денег / Money light' },
        { id: 'bank',    label: 'Огонёк банка / Bank light' },
        { id: 'world',   label: 'Огонёк мира / World light' },
        { id: 'ideas',   label: 'Огонёк идей / Ideas light' },
        { id: 'creator', label: 'Огонёк создателя / Creator light' }
      ],
      items: [
        { id: 'choice',     text: 'ВЫБОР / Choice' },
        { id: 'safety',     text: 'БЕЗОПАСНОСТЬ / Safety' },
        { id: 'path',       text: 'ПУТЬ / Path' },
        { id: 'honesty',    text: 'ЧЕСТНОСТЬ / Honesty' },
        { id: 'creation',   text: 'СОЗДАНИЕ / Creation' }
      ] },
    { id: 'q8', type: 'text', title: 'Исправь ошибки / Fix the mistakes',
      prompt: 'Перепиши без ошибок и расставь знаки: «я магу считать праверять выбирать и саздавать нимни помагает мне идти шаг за шагом». / Rewrite without mistakes (Russian sentence above).',
      placeholder: 'Я могу считать, проверять, выбирать и создавать. / I can count, check, choose and create.' },
    { id: 'q9', type: 'essay', title: 'Чему я научился с Нимни? / What did I learn with Nimny?',
      prompt: 'Напиши 5–7 предложений по-русски: чему я научился с Нимни и что хочу использовать в жизни? Используй слова: деньги, безопасность, путь, идея, создатель. / Write 5–7 Russian sentences using the keywords.',
      minSentences: 5, maxSentences: 7, placeholder: 'С Нимни я научился... / With Nimny I learned...' },
    { id: 'q10', type: 'essay', title: 'Готов открыть ночную игру / Ready to unlock the night game',
      prompt: 'Напиши 2–4 предложения: код огоньков (5 слов) и почему ты готов к ночной игре. После проверки этой миссии Нимни откроет ночную игру. / Write 2–4 sentences with the 5-word lights code and why you are ready. After this mission is checked, Nimny will unlock the night game.',
      minSentences: 2, maxSentences: 4, placeholder: 'Мой код: ВЫБОР — БЕЗОПАСНОСТЬ — ПУТЬ — ЧЕСТНОСТЬ — СОЗДАНИЕ. Я готов, потому что... / My code: Choice — Safety — Path — Honesty — Creation. I am ready because...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 10, День 5 — Финальные ворота». / Heading: "Week 10, Day 5 — Final Gate".',
    'Слой 1. Математика / Layer 1. Math: q1–q5 + опц. 1/10 от 100 = 10. / + optional one tenth.',
    'Слой 2. Русский язык / Layer 2. Russian: словарь и мини-диктант: «Я могу считать, проверять, выбирать и создавать. Нимни помогает мне идти шаг за шагом.» + правка. / vocabulary, mini-dictation, edit.',
    'Слой 3. Итоговое письмо / Layer 3. Final writing: 5–7 предложений «Чему я научился с Нимни?». / 5–7 sentences.',
    'Слой 4. Финальная сортировка / Layer 4. Final sorting: 10 карточек по 5 огонькам + 5-словный код. / 10 cards + 5-word code.',
    'Слой 5. Финальные ворота / Layer 5. Final Gate: рисунок ворот и подпись. / Gate drawing and caption.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами после проверки. / Reward in nims after parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 10, День 5 / Week 10, Day 5',
    subtitle: 'Финальные ворота: огонёк создателя / Final Gate: Creator Light',
    pages: [
      { title: 'Маршрут финальной миссии / Mission route — Final', blocks: [
        { type: 'text', text: 'Поставь штамп ✦, когда выполнено. / Stamp ✦ when done.' },
        { type: 'list', items: [
          '✦ 1. Смешанная математика / Mixed math.',
          '✦ 2. Русский язык — слова и мини-диктант / Russian — words and mini-dictation.',
          '✦ 3. Итоговое письмо «Чему я научился с Нимни?» / Final writing.',
          '✦ 4. Сортировка карточек по 5 огонькам / Sort cards into 5 lights.',
          '✦ 5. Код финальных ворот и рисунок / Final-gate code and drawing.',
          '✦ 6. Дневник мышления / Thinking diary.',
          '✦ 7. Проверка с родителем / Parent check.',
          '✦ 8. Печать миссии, готовность к ночной игре и нимы / Mission stamp, ready-for-night-game and nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика — смешанная миссия / Layer 1. Math — Mixed mission', blocks: [
        { type: 'list', items: [
          '1) Бюджет / Budget: 15 + 20 + 10 = ____ нимов; помещается ли в 50? / Fits in 50?',
          '2) Баланс / Balance: 80 + 20 − 15 = ____ нимов / nims.',
          '3) Маршрут / Route: 100 + 120 + 80 = ____ метров / meters.',
          '4) Прибыль / Profit: 60 − 35 = ____ нимов / nims.',
          '5) Время в ленте / Feed time: 5 × 40 = ____ секунд / seconds.',
          '6) Optional / Доп.: 1/10 от 100 = ____ нимов / one tenth of 100.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык — слова и мини-диктант / Layer 2. Russian — Words and Mini-Dictation', blocks: [
        { type: 'text', text: 'Финальный словарь Нимни. / Final Nimny vocabulary.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: деньги, банк, карта, маршрут, источник, создатель, идея, риск, привычка, вывод.',
          'Мини-диктант / Mini-dictation: «Я могу считать, проверять, выбирать и создавать. Нимни помогает мне идти шаг за шагом.»',
          'Исправь ошибки / Fix mistakes: «я магу считать праверять выбирать и саздавать нимни помагает мне идти шаг за шагом».',
          'Орфограмма дня / Spelling rule of the day: повтор всех правил недели. / Review of the week\'s rules.'
        ] }
      ] },
      { title: 'Слой 3. Чтение и итоговое письмо / Layer 3. Reading and Final Writing', blocks: [
        { type: 'list', items: [
          'Прочитай ещё раз финальный словарь. / Re-read the final vocabulary.',
          'Напиши 5–7 предложений «Чему я научился с Нимни и что хочу использовать в жизни?» / Write 5–7 Russian sentences "What did I learn with Nimny and what do I want to use in real life?": ____________________________________________',
          'Используй слова: деньги, безопасность, путь, идея, создатель / Use the keywords.'
        ] }
      ] },
      { title: 'Слой 4. Финальные карточки и сортировка / Layer 4. Final Cards and Sorting', blocks: [
        { type: 'text', text: 'Распредели 10 карточек по 5 огонькам. / Sort 10 cards into 5 lights.' },
        { type: 'list', items: [
          '«бюджет» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«PIN» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«масштаб» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«прибыль» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«источник» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«карта» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«риск» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«creator» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«проверить информацию» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель',
          '«отложить часть» → ▢ Деньги ▢ Банк ▢ Мир ▢ Идеи ▢ Создатель'
        ] }
      ] },
      { title: 'Слой 5. Финальные ворота — код огоньков и рисунок / Layer 5. Final Gate — Lights Code and Drawing (practical)', blocks: [
        { type: 'text', text: 'Подбери одно слово к каждому огоньку и нарисуй финальные ворота. / Match one word to each light and draw the final gate.' },
        { type: 'list', items: [
          'Огонёк денег / Money light → ВЫБОР / Choice',
          'Огонёк банка / Bank light → БЕЗОПАСНОСТЬ / Safety',
          'Огонёк мира / World light → ПУТЬ / Path',
          'Огонёк идей / Ideas light → ЧЕСТНОСТЬ / Honesty',
          'Огонёк создателя / Creator light → СОЗДАНИЕ / Creation',
          'Код финальных ворот / Final-gate code: ВЫБОР — БЕЗОПАСНОСТЬ — ПУТЬ — ЧЕСТНОСТЬ — СОЗДАНИЕ / Choice — Safety — Path — Honesty — Creation.',
          'Рисунок финальных ворот / Final-gate drawing: ▢▢▢',
          'Подпись / Caption: «Я собрал огоньки знаний.»'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Какая миссия была самой лёгкой? / Which mission was easiest? ___________________',
          'Какая была самой трудной? / Which was hardest? ___________________',
          'Что я хочу использовать в жизни? / What do I want to use in real life? ___________________'
        ] }
      ] },
      { title: 'Родительская проверка, готовность к ночной игре и награда нимами / Parent check, ready-for-night-game and reward in nims', blocks: [
        { type: 'list', items: [
          'Печать миссии / Mission stamp: ▢ ✦ ФИНАЛЬНЫЕ ВОРОТА ОТКРЫТЫ ✦ / FINAL GATE OPENED.',
          'Готов к ночной игре / Ready for the night game: ▢ да / yes ▢ ещё думаю / still thinking.',
          'Базовая награда / Base reward: 5 нимов / nims ✓',
          'Бонус за точные расчёты финального квеста / Bonus for accurate final-quest math: +1 ☐',
          'Бонус за правильный код огоньков / Bonus for the correct lights code: +1 ☐',
          'Бонус за сильный итоговый вывод / Bonus for a strong final reflection: +1 ☐',
          'Итого / Total: ____ из / of 8 нимов / nims',
          'После проверки этой миссии Нимни откроет для тебя ночную игру. / After this mission is checked, Nimny will unlock the night game for you.'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Финальная квестовая миссия Недели 10 и итог 10-недельного пути. Только учебная миссия. Самостоятельная работа; роль родителя — короткое введение (3–5 минут), помощь только если ребёнок застрял, и финальная проверка (5–10 минут). Не экзамен. / Final quest mission of Week 10 and end of the 10-week path. Educational only. Child-led; parent gives 3–5 min intro, helps only if stuck, 5–10 min final check. Not a test.',
    safetyNote: 'Только учебная симуляция. Никаких реальных вложений, открытия счетов, переписки с незнакомцами или личных данных. / Educational simulation only. No real investing, accounts, contacting strangers or personal data.',
    mathGoal: 'q1: 15+20+10 = 45; помещается. q2: 80+20−15 = 85. q3: 100+120+80 = 300 м. q4: 60−35 = 25. q5: 5×40 = 200 с. Опц.: 1/10 от 100 = 10. / Listed.',
    russianGoal: 'Финальный словарь запомнен; мини-диктант чистый; правка корректна. / Vocabulary recalled; clean dictation; edit correct.',
    readingWritingGoal: '5–7 предложений по-русски с минимум 3 ключевыми словами; идея — что используешь в жизни. / 5–7 Russian sentences using ≥ 3 keywords.',
    missionGoal: '10 карточек распределены по 5 огонькам без явных ошибок (некоторые карточки могут попасть в 1–2 категории — например, «отложить часть» в Деньги или Создатель). / 10 cards sorted; some cards may fit 2 lights.',
    practicalGoal: 'Код огоньков из 5 слов составлен корректно; рисунок финальных ворот подписан «Я собрал огоньки знаний»; ребёнок отметил готовность к ночной игре. / 5-word lights code correct; gate drawing signed; ready-for-night-game ticked.',
    finalRubric: [
      'Все 5 расчётов финального квеста посчитаны верно. / All 5 final-quest calculations correct.',
      'Финальная сортировка по 5 огонькам выполнена. / Final sorting into 5 lights done.',
      'Код огоньков: ВЫБОР — БЕЗОПАСНОСТЬ — ПУТЬ — ЧЕСТНОСТЬ — СОЗДАНИЕ. / Lights code: Choice — Safety — Path — Honesty — Creation.',
      'Итоговое письмо 5–7 предложений по-русски. / 5–7 sentence final writing.',
      'Рисунок финальных ворот подписан. / Gate drawing signed.',
      'Готовность к ночной игре отмечена. / Ready-for-night-game ticked.',
      'Никаких реальных счетов, личных данных или публикаций. / No real accounts, personal data or publishing.'
    ],
    check: [
      'Q1: 45 нимов; помещается / fits.',
      'Q2: 85 нимов / 85 nims.',
      'Q3: 300 м / 300 m.',
      'Q4: 25 нимов / 25 nims.',
      'Q5: 200 секунд / 200 s.',
      '10 карточек по 5 огонькам / 10 cards into 5 lights.',
      'Код огоньков: ВЫБОР — БЕЗОПАСНОСТЬ — ПУТЬ — ЧЕСТНОСТЬ — СОЗДАНИЕ.',
      'Итоговое письмо 5–7 предложений / 5–7 sentence final writing.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '15 + 20 + 10 = 45 нимов; помещается в 50. / 45 nims; fits.' },
      { taskId: 'q2', answer: '80 + 20 − 15 = 85 нимов. / 85 nims.' },
      { taskId: 'q3', answer: '100 + 120 + 80 = 300 метров. / 300 m.' },
      { taskId: 'q4', answer: '60 − 35 = 25 нимов прибыли. / 25 nims.' },
      { taskId: 'q5', answer: '5 × 40 = 200 секунд. / 200 s.' },
      { taskId: 'q6', answer: 'Деньги: бюджет, отложить часть. Банк: PIN. Мир: масштаб, карта. Идеи: прибыль, риск. Создатель: источник, creator, проверить информацию. (Карточка «отложить часть» может попасть и в Деньги, и в Создатель — принимаем разумный вариант.) / Listed; some cards fit 2 lights.' },
      { taskId: 'q7', answer: 'Огонёк денег → ВЫБОР. Огонёк банка → БЕЗОПАСНОСТЬ. Огонёк мира → ПУТЬ. Огонёк идей → ЧЕСТНОСТЬ. Огонёк создателя → СОЗДАНИЕ.' },
      { taskId: 'q8', answer: 'Я могу считать, проверять, выбирать и создавать. Нимни помогает мне идти шаг за шагом.' },
      { taskId: 'q9', answer: 'Открытый ответ. 5–7 предложений с идеей: бюджет и выбор, безопасность и проверка, карта и измерение, честная идея и риск, создатель и полезный вывод. / Open answer.' },
      { taskId: 'q10', answer: 'Открытый ответ. 2–4 предложения с кодом ВЫБОР — БЕЗОПАСНОСТЬ — ПУТЬ — ЧЕСТНОСТЬ — СОЗДАНИЕ и обоснованием готовности к ночной игре. / Open answer.' }
    ],
    spellingCheck: 'Словарь и диктант чистые; правка корректна. / Vocabulary recalled; clean dictation; edit correct.',
    readingCheck: '5–7 предложений по-русски; ключевые слова использованы. / 5–7 Russian sentences with keywords.',
    missionCheck: 'Финальная сортировка и код огоньков выполнены без явных ошибок. / Final sorting and lights code completed.',
    notebookCheck: 'Дневник мышления заполнен; рисунок финальных ворот подписан. / Diary filled; gate drawing signed.',
    printCheck: 'Все 8 страниц паспорта финальной миссии заполнены. / All 8 final-mission pages completed.',
    discussionPrompts: [
      'Какая миссия была самой лёгкой? / Which mission was easiest?',
      'Какая была самой трудной? / Which was hardest?',
      'Что одно ты хочешь использовать в жизни? / What is one thing you want to use in real life?',
      'Что значит «создатель»? / What does "creator" mean?',
      'Почему важно проверять информацию? / Why is checking information important?'
    ],
    parentRoleNote: 'Введение 3–5 минут, помощь только если застрял, финальная проверка 5–10 минут и начисление нимов. После проверки можно сообщить ребёнку, что ночная игра готова открыться (логика unlock — в Part C). Не экзамен. / 3–5 min intro, help only if stuck, 5–10 min final check, then award nims. After check, tell the child the night game is ready to unlock (unlock logic in Part C). Not a test.',
    ifEasy: 'Усложните: пусть ребёнок объяснит код огоньков своими словами одним предложением на каждый огонёк. / Make harder: explain each light in one sentence.',
    ifDifficult: 'Сократите: оставьте q1, q6 (5 карточек) и q7 (3 огонька); итоговое письмо — 3 предложения. / Make easier: keep q1, q6 (5 cards) and q7 (3 lights); 3-sentence final writing.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 5, max: 8,
    label: 'Награда за финальную миссию / Final mission reward', display: '5 нимов / 5 nims',
    bonuses: [
      { id: 'final-quest-math', label: 'Бонус за точные расчёты финального квеста / Bonus for accurate final-quest math', amount: 1 },
      { id: 'final-code', label: 'Бонус за правильный код огоньков / Bonus for the correct lights code', amount: 1 },
      { id: 'creator-reflection', label: 'Бонус за сильный итоговый вывод / Bonus for a strong final reflection', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q6', 'q7', 'q9', 'q10'], allowNotebookCompletion: true },
  completesWeek: true,
  nextLessonId: 'max-week-10-night-run'
};

export default maxWeek10Day5;
